import { api } from '@/fsd/shared/api';
import { IAccessMember } from '../../model/types/IAccessMember';

export const getAccessMember = async () => {
  const data = await api.get<{ sections: IAccessMember[] }>(
    '/api/v1/access/member/'
  );

  return data.sections;
};
